__turbopack_context__.v({
  "answer": "Form-module__ETr9sW__answer",
  "error": "Form-module__ETr9sW__error",
  "form": "Form-module__ETr9sW__form",
  "formButton": "Form-module__ETr9sW__formButton",
  "loader": "Form-module__ETr9sW__loader",
  "loading": "Form-module__ETr9sW__loading",
  "questionBox": "Form-module__ETr9sW__questionBox",
  "spin": "Form-module__ETr9sW__spin",
  "text": "Form-module__ETr9sW__text",
  "textarea": "Form-module__ETr9sW__textarea",
  "toastContainer": "Form-module__ETr9sW__toastContainer",
});
